// Delegation also handles links rendered after page navigation. Links open a
// new tab, so analytics never needs to delay or prevent the reader's click.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-preferred-source-placement]');
  if (!link) return;

  const params = {
    placement: link.dataset.preferredSourcePlacement,
    link_url: 'https://www.google.com/preferences/source?q=teambuilding.com',
    transport_type: 'beacon'
  };
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'preferred_source_clicked', params);
  } else {
    window.dataLayer = window.dataLayer || [];
    function queueEvent() { window.dataLayer.push(arguments); }
    queueEvent('event', 'preferred_source_clicked', params);
  }
});
